import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import _ from "lodash";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;
export interface IInvoiceWithCost {
	Invoice_ID: number;
	Item_Cost: number;
}

export const { thunk: updateCostPerTicket, slice: updateCostPerTicketSlice } = getThunkAndSlice<
	{
		UpdatedCosts: Array<IInvoiceWithCost>;
	},
	typeof initialState
>({
	initialState,
	path: "/api/System/UpdateCostPerTicket",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const costMap = new Map<number, number>();
		params.UpdatedCosts.forEach((param) => {
			costMap.set(param.Invoice_ID, Number(param.Item_Cost));
		});
		const newData = rootState.pricing.eventInventoryAll.data.map((event) => {
			const newItemCost = costMap.get(event.Invoice_ID || 0);
			return {
				...event,
				Item_Cost: !_.isNil(newItemCost) && !!event.Invoice_ID ? newItemCost : event.Item_Cost,
			};
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId: getInventoryCacheEventId(rootState) }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				const newCost = costMap.get(item.Invoice_ID || 0);
				return {
					...item,
					Listing_Cost: !_.isNil(newCost) && !!item.Invoice_ID ? newCost : item.Listing_Cost,
				};
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
